"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.langKey = exports.getCurrency = void 0;
exports.getTranslations = getTranslations;
exports.translate = translate;
exports.getCurrentLanguage = getCurrentLanguage;
exports.getLanguageList = getLanguageList;
const i18n_1 = require("./i18n");
var currencies_1 = require("./currencies");
Object.defineProperty(exports, "getCurrency", { enumerable: true, get: function () { return currencies_1.getCurrency; } });
function getTranslations(lang) {
    return i18n_1.translations[lang] || i18n_1.translations.en;
}
function translate(key, lang = 'en', params) {
    const translation = getTranslations(lang);
    let result = translation[key] || key;
    if (params) {
        for (const [paramKey, paramValue] of Object.entries(params)) {
            result = result.split(`{${paramKey}}`).join(String(paramValue));
        }
    }
    return result;
}
exports.langKey = '_lang';
function getCurrentLanguage() {
    if (typeof localStorage !== 'undefined') {
        return localStorage.getItem(exports.langKey) || 'en';
    }
    return 'en';
}
function getLanguageList() {
    return Object.keys(i18n_1.translations);
}
